import {Component, Input, Host, OnInit, Injector, ChangeDetectionStrategy} from '@angular/core';
import { CheckboxGroupComponent } from './checkbox-group.component';

import { BaseComponents } from '../../../base.component';
@Component({
    selector: 'checkbox',
    template: `
    <div (click)="toggleCheck()">
        <input type="checkbox" [checked]="isChecked()" class="uk-checkbox uk-position-left +top-8"/>
        <ng-content></ng-content>
    </div>`,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CheckboxComponent extends BaseComponents implements OnInit{
    @Input() value: any;

    constructor(
        protected injectorObj:Injector,
        @Host() private checkboxGroup: CheckboxGroupComponent
    ) {
        super(injectorObj);
    }

    ngOnInit(){
        this.isChecked()
    }

    toggleCheck() {
        this.checkboxGroup.addOrRemove(this.value);
    }

    isChecked() {
        return this.checkboxGroup.contains(this.value);
    }
}
